import { principles, industryStats } from "@/mocks/chigua";
import SectionHeading from "@/components/chigua/SectionHeading";

export default function HowWeVerify() {
  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="内容立场"
          title="我们如何甄别“内幕”"
          desc="谈论内幕消息与内幕真相，前提是有一套看得见的方法。下面是我们整理每一篇复盘时都会遵守的四条原则。"
        />

        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-4">
          {principles.map((p, i) => (
            <article
              key={p.n}
              className={`rounded-xl border p-6 transition hover:-translate-y-1 ${
                i % 2 === 0 ? "border-background-200 bg-background-100/60" : "border-secondary-200 bg-secondary-100/50"
              }`}
            >
              <span className="font-display-sc text-5xl leading-none text-foreground-950/90">{p.n}</span>
              <h3 className="mt-4 flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <span className="grid h-6 w-6 place-items-center rounded bg-primary-100 text-xs text-primary-700">
                  <i className={`${i === 1 ? "ri-shield-star-line" : i === 2 ? "ri-node-tree" : i === 3 ? "ri-scales-3-line" : "ri-archive-line"}`} aria-hidden="true" />
                </span>
                {p.title}
              </h3>
              <p className="mt-3 text-sm leading-6 text-foreground-600">{p.text}</p>
            </article>
          ))}
        </div>

        {/* 数据条 */}
        <div className="mt-8 grid grid-cols-2 gap-5 overflow-hidden rounded-xl bg-foreground-950 px-6 py-8 text-background-100 md:grid-cols-4 md:px-10">
          {industryStats.map((s) => (
            <div key={s.label} className="text-center">
              <p className="font-display-sc text-3xl font-bold text-secondary-300 md:text-4xl">{s.value}</p>
              <p className="mt-2 text-xs text-background-400">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}